import { DialogActions } from '@mui/material';
import React from 'react';
import { withStyles } from 'tss-react/mui';
import { ModalFullPageRenderCallbackArgs } from './ModalFullPage.component';


const _ModalFullPageActions: React.FC<ModalFullPageRenderCallbackArgs> = (props) => (
  <DialogActions {...props} />
);


// TODO jss-to-tss-react codemod: Unable to handle style definition reliably. Unsupported arrow function syntax.
// Arrow function has body type of BlockStatement instead of ObjectExpression.
export const ModalFullPageActions = withStyles(_ModalFullPageActions, (theme, { displayMobileOnlyStyles, showBottomDivider = true }) => ({
  root: (() => {
    if (displayMobileOnlyStyles) return ({
      padding: theme.spacing(2),
      boxShadow: showBottomDivider ? `inset 0 1px 0 ${theme.palette.divider}` : 'none',
      paddingTop: showBottomDivider ? theme.spacing(2) : theme.spacing(1),
      '& > button': {
        flex: 1
      }
    });
    return {
      padding: theme.spacing(2),
      '& > button': {
        flex: 'unset'
      }
    };
  })()
}), { name: 'ModalFullPageActions' });

